// Signin
export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SET_ACCOUNT_ID = 'LOGIN_SET_ACCOUNT_ID'
export const LOGIN_LOGGED_IN = 'LOGIN_LOGGED_IN'
export const LOGIN_LOGGED_OUT = 'LOGIN_LOGGED_OUT'
